export
const name: string = "SvSide";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec4  aVertexAttrib0;
    attribute vec4  aVertexAttrib1;
    attribute vec4  aVertexAttrib2;
    attribute vec4  aVertexAttrib3;
    attribute float aVertexID;
    attribute float a_visibility;
    attribute float a_manipulation;

    uniform   int   u_side;
    uniform   vec4  u_sun_position;
    uniform   mat4  u_view_projection;
    uniform   mat4  u_manipulator;
    uniform   mat4  u_manipulator_inv;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    int greaterVec(vec3 a, vec3 b)
    {
      return int(dot(sign(a - b), vec3(4.0, 2.0, 1.0)));
    }

    int computeMult(vec3 A, vec3 B, vec3 C, vec4 L)
    {
      vec3 n = cross(C - A, L.xyz - A * L.w);
      return int(sign(dot(B - A, n)));
    }

    void main()
    {
        vec4 position = vec4(0.0);

        vec4 sun_position = u_sun_position;
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            sun_position = u_manipulator_inv * u_sun_position;
        }
    #endif
        int vertexIDCCW = int(int(aVertexID) > 2 ? int(aVertexID) - 2 : 2 - int(aVertexID));
        int vertexIDCW  = int(int(aVertexID) > 2 ? 6 - int(aVertexID) : int(aVertexID));
        int sideID      = int(u_side);

        vec4 P[4];
        P[0] = vec4(aVertexAttrib0.xyz, 1);
        P[1] = vec4(aVertexAttrib1.xyz, 1);
        P[2] = vec4(P[0].xyz * sun_position.w - sun_position.xyz, 0);
        P[3] = vec4(P[1].xyz * sun_position.w - sun_position.xyz, 0);

        int multiplicity = 0;
        if (2 - 2 < int(aVertexAttrib0.w)) {
            if (greaterVec(P[0].xyz, aVertexAttrib2.xyz) > 0) {
                multiplicity += computeMult(aVertexAttrib2.xyz, P[0].xyz, P[1].xyz, sun_position);
            }
            else if (greaterVec(P[1].xyz, aVertexAttrib2.xyz) > 0) {
                multiplicity -= computeMult(P[0].xyz, aVertexAttrib2.xyz, P[1].xyz, sun_position);
            }
            else {
                multiplicity += computeMult(P[0].xyz,P[1].xyz, aVertexAttrib2.xyz, sun_position);
            }
        }

        if (3 - 2 < int(aVertexAttrib0.w)) {
            if (greaterVec(P[0].xyz, aVertexAttrib3.xyz) > 0) {
                multiplicity += computeMult(aVertexAttrib3.xyz, P[0].xyz, P[1].xyz, sun_position);
            }
            else if (greaterVec(P[1].xyz, aVertexAttrib3.xyz) > 0) {
                multiplicity -= computeMult(P[0].xyz, aVertexAttrib3.xyz, P[1].xyz, sun_position);
            }
            else {
                multiplicity += computeMult(P[0].xyz, P[1].xyz, aVertexAttrib3.xyz, sun_position);
            }
        }

        if (sideID < int(abs(float(multiplicity)))){
            mat4 manipulatorTrafo = mat4(1.0);
    #ifdef MANIPULATOR_ENABLED
            if (a_manipulation > 0.5) {
                manipulatorTrafo = u_manipulator;
            }
    #endif
            if (multiplicity > 0) {
                for (int i = 0; i < 4; ++i) {
                    if (i == vertexIDCCW) {
                        position = u_view_projection * manipulatorTrafo * P[i];
                    }
                }
            }

            if (multiplicity < 0) {
                for(int i = 0; i < 4; ++i) {
                    if (i == vertexIDCW) {
                        position = u_view_projection * manipulatorTrafo * P[i];
                    }
                }
            }
        }
        else {
            position = vec4(0, 0, 0, 0);
        }

        gl_Position = position * a_visibility;
    }
`;
